import styled from "@emotion/styled";
import { COLOR_MAP } from "../../constants/ColorNames";
import { Required_Icon } from "../../constants/icons/RequiredIcon";

type LabelProps = {
    label: string,
    required?: boolean,
    labelFor?: string,
    colorType: 'dark' | 'light',
    subLabel?: string,
    whiteSpace?: string
}


const StyledIcon = styled.span`
    position: absolute;
    top: -0.5rem;
    padding-left: 0.2rem;
`
type ColorProps = {
    colorType: 'dark' | 'light'
}

const StyledLabel = styled.label<ColorProps>((props) => ({
    position: 'relative',
    fontWeight: props.colorType === 'dark' ? '700' : '400',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: props.colorType === 'dark' ? COLOR_MAP.GREY_2 : COLOR_MAP.LIGHT_GREY,
    display: 'block'
}))

const SubLabel = styled.span`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${COLOR_MAP.GREY_1};
  margin-left: 0.4rem;
`

const Label = (props: LabelProps) => {
    const { label, required = false, labelFor = '', colorType = 'light', subLabel, whiteSpace } = props
    return <StyledLabel
        style={{ whiteSpace: whiteSpace ? 'nowrap' : 'inherit' }}
        colorType={colorType}
        htmlFor={labelFor}
        >
        {label}
        {subLabel &&
            <SubLabel>
                {subLabel}
            </SubLabel>}
        {required
            && <StyledIcon>{Required_Icon}</StyledIcon>
        }
    </StyledLabel>

}

export default Label;